module.exports = __webpack_public_path__ + "static/media/fcmb.798686d2.svg";